import React from 'react';
import SyncIcon from '@material-ui/icons/Sync';
import { Box } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { iconStyle, iconWrapperStyle, lastSyncWrapperStyle } from './style';






export default function LastSyncInfo({ lastSyncInSecond, sync }) {
  return (
    React.createElement(Button, { style: lastSyncWrapperStyle, onClick: () => sync(),}
      , React.createElement(Box, { style: iconWrapperStyle,}
        , React.createElement(SyncIcon, { style: iconStyle,} )
      ), "Last synced:"

      , React.createElement(Box, { style: { fontWeight: 'bold' },}, " "
        , Math.round(lastSyncInSecond), " "
      ), "seconds ago"

    )
  );
}
